/**
 * @generated SignedSource<<9fa53303c39232d207c2d3f37618c36d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type statementsPage_Query$variables = Record<PropertyKey, never>;
export type statementsPage_Query$data = {
  readonly accountsRegistry: {
    readonly accounts: ReadonlyArray<{
      readonly bank: string | null | undefined;
      readonly coveredMonths: number | null | undefined;
      readonly files: ReadonlyArray<{
        readonly endDate: string | null | undefined;
        readonly filename: string | null | undefined;
        readonly provider: string | null | undefined;
        readonly startDate: string | null | undefined;
        readonly state: string;
        readonly txnCount: number;
        readonly uploadedAt: string;
      }>;
      readonly firstMonth: string | null | undefined;
      readonly gapMonths: ReadonlyArray<string>;
      readonly kind: string;
      readonly lastMonth: string | null | undefined;
      readonly monthly: ReadonlyArray<{
        readonly balance: number | null | undefined;
        readonly cashIn: number;
        readonly cashOut: number;
        readonly month: string;
        readonly net: number;
      }>;
      readonly nickname: string | null | undefined;
      readonly number: string;
      readonly providers: ReadonlyArray<string>;
      readonly staleSince: string | null | undefined;
      readonly txnCount: number;
    }>;
    readonly expectedSources: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly note: string | null | undefined;
    }>;
  };
};
export type statementsPage_Query = {
  response: statementsPage_Query$data;
  variables: statementsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bank",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providers",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "txnCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstMonth",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastMonth",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coveredMonths",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gapMonths",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staleSince",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadedAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cashIn",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cashOut",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "net",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpectedSource",
  "kind": "LinkedField",
  "name": "expectedSources",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "statementsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsRegistry",
        "kind": "LinkedField",
        "name": "accountsRegistry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RegistryAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StatementFile",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMonth",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "statementsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsRegistry",
        "kind": "LinkedField",
        "name": "accountsRegistry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RegistryAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StatementFile",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v16/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMonth",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v23/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "38cc5709548d7e832cec627c3d62bc12",
    "id": null,
    "metadata": {},
    "name": "statementsPage_Query",
    "operationKind": "query",
    "text": "query statementsPage_Query {\n  accountsRegistry {\n    accounts {\n      number\n      nickname\n      kind\n      bank\n      providers\n      txnCount\n      firstMonth\n      lastMonth\n      coveredMonths\n      gapMonths\n      staleSince\n      files {\n        filename\n        provider\n        startDate\n        endDate\n        state\n        txnCount\n        uploadedAt\n        id\n      }\n      monthly {\n        month\n        cashIn\n        cashOut\n        net\n        balance\n        id\n      }\n      id\n    }\n    expectedSources {\n      id\n      name\n      note\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c19b116d27d50497fdba1f47b89d18d";

export default node;
